export enum VariantButton {
  General = "General",
  BLACK = "Black",
  Red = "Red",
  White = "White",
}
